/**
 * ==========================================================
 * QUICK VARIANT BADGES LOADER
 * ==========================================================
 */

(() => {

    let raf = null;
    let retryTimer = null;
    let retryCount = 0;

    const MAX_RETRIES = 30;


    /* ==========================================================
       EXECUTA APPLY BADGES
    ========================================================== */

    function run() {

        if (typeof window.applyBadges === 'function') {

            retryCount = 0;

            if (retryTimer) {
                clearTimeout(retryTimer);
                retryTimer = null;
            }

            window.applyBadges();

            return;
        }


        /* Aguarda o quick-variant-badges.js carregar */

        if (retryCount < MAX_RETRIES) {

            retryCount++;

            if (retryTimer) {
                clearTimeout(retryTimer);
            }

            retryTimer = setTimeout(() => {

                retryTimer = null;

                run();

            }, 150);

        }

    }


    /* ==========================================================
       PRIMEIRA EXECUÇÃO
    ========================================================== */

    if (document.readyState === 'loading') {

        document.addEventListener(
            'DOMContentLoaded',
            run
        );

    } else {

        run();

    }


    window.addEventListener(
        'load',
        run
    );


    /* ==========================================================
       OBSERVER
    ========================================================== */

    const observer = new MutationObserver(mutations => {

        let shouldRun = false;


        for (const mutation of mutations) {

            for (const node of mutation.addedNodes) {

                if (!(node instanceof HTMLElement)) {
                    continue;
                }


                /* ==================================================
                   IGNORA ALTERAÇÕES FEITAS PELO PRÓPRIO SCRIPT
                ================================================== */

                if (
                    node.classList?.contains('na-custom-badge') ||
                    node.classList?.contains('na-product-badges')
                ) {
                    continue;
                }


                /* ==================================================
                   NOVO CARD OU GALERIA
                ================================================== */

                if (
                    node.matches?.('product-card') ||
                    node.querySelector?.('product-card') ||

                    node.matches?.('.custom-product-card-media') ||
                    node.querySelector?.('.custom-product-card-media') ||

                    node.matches?.('.card-gallery') ||
                    node.querySelector?.('.card-gallery')
                ) {

                    shouldRun = true;

                    break;
                }

            }


            if (shouldRun) {
                break;
            }

        }


        if (!shouldRun || raf) {
            return;
        }


        raf = requestAnimationFrame(() => {

            raf = null;

            run();

        });

    });


    /* ==========================================================
       INICIA OBSERVER
    ========================================================== */

    observer.observe(
        document.body,
        {
            childList: true,
            subtree: true
        }
    );


    /* ==========================================================
       SHOPIFY - SEÇÕES CARREGADAS DINAMICAMENTE
    ========================================================== */

    document.addEventListener(
        'shopify:section:load',
        run
    );

})();